import type { Distance, SpatialRectangle } from "@pdfking/math"
import { Center, Min, Scale, Subtract, Total } from "@pdfking/math"
import type { PageShape } from "@pdfking/renderer-api"
import { HorizontalAlign, Oval, PlotFunction } from "@pdfking/renderer-api"

import { PALETTE } from "#constants"

import { PlainText } from "../text/PlainText"

/** A disc in the primary as wide as `box` allows, at its centre, `lines` on
 * it in the paper, centred: the logo's, or a month's name. In the `spot`
 * too, a logo: the pantone and the UV print it, its lines holed out. */
export const DrawBadge = ({
  box,
  lines,
  spot,
}: {
  box: SpatialRectangle<Distance>
  lines: string[]
  spot: boolean
}): PageShape[] => {
  const diameter = Min(box.width, box.height)
  const radius = Scale(diameter, 0.5)
  const center = Center(box)
  const font = Scale(diameter, Min(0.18, 1.6 / Total(lines.length, 2)))
  const first = Total(center.y, Scale(font, 0.6 * lines.length - 1.1))
  const disc = Oval(center, radius)
  return [
    ...(spot ? [PALETTE.primary, PALETTE.spot] : [PALETTE.primary]).map(
      (fill_color): PageShape => ({
        closed: true,
        enum: PlotFunction.PLOT_PATH,
        fill_color,
        points: disc,
      })
    ),
    ...lines.map((line, i) =>
      PlainText(
        line,
        Subtract(center.x, radius),
        diameter,
        Subtract(first, Scale(font, 1.2 * i)),
        font,
        PALETTE.paper,
        HorizontalAlign.CENTER
      )
    ),
  ]
}
